import type { ReactNode } from "react";

/** 列表页的筛选栏，控件全部用紧凑尺寸。筛选变化立即生效，或由 actions 里的查询按钮提交。
 * actions 是紧跟在筛选控件后的一组按钮（如查询、筛选条件、清除筛选），组内不拆开，换行时整组一起换，始终贴着最后一个筛选控件；right 推到最右。 */
export function Toolbar({ children, actions, right }: { children: ReactNode; actions?: ReactNode; right?: ReactNode }) {
  return (
    <div className="ax-toolbar">
      {children}
      {actions && <div className="ax-toolbar-actions">{actions}</div>}
      {right && <div className="ax-toolbar-right">{right}</div>}
    </div>
  );
}

export function ToolbarCount({ children }: { children: ReactNode }) {
  return <span className="ax-toolbar-count">{children}</span>;
}
